import { CabinPreferenceEnum } from '../../../../../../interfaces/src/lib/enums/index';
import { CategoriesRequest } from '../../../../../../interfaces/src/lib/interfaces/index';

export const requestAllCategoriesMock: CategoriesRequest = {
  isFlightIncluded: false,
  passengerInformation: {
    passengerType: '',
    adults: {
      total: 2,
      details: [
        {
          age: 34,
        },
        {
          age: 30,
        },
      ],
    },
    children: {
      total: 1,
      details: [
        {
          age: 3,
        },
      ],
    },
  },
  priceTypes: [
    {
      id: 'PROMOMKT',
    },
  ],
  priceCodes: [
    {
      code: 'DIC00969GB5014PR',
    },
  ],
  cabinTypes: [{ code: 'Interior' }],
  cabinPreferences: [CabinPreferenceEnum.REAL],
  categories: [
    {
      code: 'IR1',
    },
  ],
};
